export const objectivesQueryKeys = {
  all: (orgId: string) => ['objectives', orgId] as const,
  byId: (orgId: string, objectiveId: number | undefined) =>
    ['objectives', orgId, objectiveId ?? 'none'] as const,
  list: {
    infinite: (orgId: string) => ['objectives', orgId, 'infinite'] as const,
    infiniteByLoopId: (orgId: string, loopId: number) =>
      ['objectives', orgId, 'infinite', { loopId }] as const,
  },
  keyResults: {
    byObjectiveId: (orgId: string, objectiveId: number) =>
      ['objectives', orgId, objectiveId, 'key-results'] as const,
  },
  itemObjectives: {
    byObjectiveId: (orgId: string, objectiveId: number) =>
      ['objectives', orgId, objectiveId, 'item-objectives'] as const,
  },
};
